import React, { useState, useEffect } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import { dataService } from "../services/dataService";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import FloatingLabelInput from "../components/form_elements/FloatingLabelInput";
import FloatingSelectInput from "../components/form_elements/FloatingSelectInput";
import ShoeLoader from "../components/loaders/ShoeLoader";
import { IconCopyPlus } from "@tabler/icons-react";

const AdatVenyes = () => {
    const { order, updateOrder } = useOrder();
    const navigate = useStepNavigate();
    const [orvosok, setOrvosok] = useState([]);
    const [loading, setLoading] = useState(false);
    const [orvosSearch, setOrvosSearch] = useState("");
    const [filteredOrvosok, setFilteredOrvosok] = useState([]);
    const [orvosSelectValue, setOrvosSelectValue] = useState("");

    const [isAddingDoctor, setIsAddingDoctor] = useState(false);
    const [newDoctor, setNewDoctor] = useState({ name: "", code: "" });
    const [errorMessage, setErrorMessage] = useState("");

    const aktVeny = order.venyek[order.aktivVenyIndex] || {};

    const fillTestData = () => {
        const testBnoCode = "M79.0";
        setFormData({
            veny_receipt: "123456789012345678",
            veny_inscript_date: "2024-01-15",
            veny_nine_digit_id: "123456789",
            veny_med_name: "Dr. Teszt Béla",
            veny_med_stamp_num: "12345",
            veny_bno_code: testBnoCode,
            veny_med_id: orvosok.length > 0 ? orvosok[0].doctor_szam : "",
        });
        setBnoSearch(testBnoCode);
        setLastSelectedBno(testBnoCode);
        setHasSelectedBno(true);
        setSelectedBnoName("");

        if (orvosok.length > 0) {
            setOrvosSearch(orvosok[0].doctor_full_name);
            setOrvosSelectValue(String(orvosok[0].doctor_szam));
        } else {
            setOrvosSearch("Dr. Teszt Béla");
        }
    };

    const [formData, setFormData] = useState({
        veny_receipt: aktVeny.veny_receipt || "",
        veny_inscript_date: aktVeny.veny_inscript_date || "",
        veny_nine_digit_id: aktVeny.veny_nine_digit_id || "",
        veny_med_name: aktVeny.veny_med_name || "",
        veny_med_stamp_num: aktVeny.veny_med_stamp_num || "",
        veny_bno_code: aktVeny.veny_bno_code || "",
        veny_med_id: aktVeny.veny_med_id || "",
    });

    useEffect(() => {
        setLoading(true);
        dataService
            .getDoctors()
            .then((response) => {
                console.log("API válasz:", response.data);
                if (response.data?.status === "ok") {
                    const doctorsData = response.data.data;
                    setOrvosok(doctorsData || []);
                    setLoading(false);
                } else {
                    setLoading(false);
                    alert("Hiba történt az orvosok betöltésekor!");
                }
            })
            .catch((err) => {
                setLoading(false);
                console.error("Error fetching doctors:", err);
                alert("Hiba történt az orvosok betöltésekor!");
            });
    }, []);

    useEffect(() => {
        const aktVeny = order.venyek[order.aktivVenyIndex] || {};
        const isUres = !aktVeny.veny_receipt && !aktVeny.veny_inscript_date && !aktVeny.veny_nine_digit_id && !aktVeny.veny_med_name && !aktVeny.veny_med_stamp_num && !aktVeny.veny_bno_code && !aktVeny.veny_med_id;
        setFormData(
            isUres
                ? {
                        veny_receipt: "",
                        veny_inscript_date: "",
                        veny_nine_digit_id: "",
                        veny_med_name: "",
                        veny_med_stamp_num: "",
                        veny_bno_code: "",
                        veny_med_id: "",
                    }
                : {
                        veny_receipt: aktVeny.veny_receipt || "",
                        veny_inscript_date: aktVeny.veny_inscript_date || "",
                        veny_nine_digit_id: aktVeny.veny_nine_digit_id || "",
                        veny_med_name: aktVeny.veny_med_name || "",
                        veny_med_stamp_num: aktVeny.veny_med_stamp_num || "",
                        veny_bno_code: aktVeny.veny_bno_code || "",
                        veny_med_id: aktVeny.veny_med_id || "",
                    }
        );
        setOrvosSearch(aktVeny.veny_med_name || "");
        setBnoSearch(aktVeny.veny_bno_code || "");
        setLastSelectedBno(aktVeny.veny_bno_code || "");
        setHasSelectedBno(Boolean(aktVeny.veny_bno_code));
        setSelectedBnoName("");
    }, [order.aktivVenyIndex, order.venyek.length]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const cancelAdd = () => {
        if (order.venyek.length > 1) {
            const updatedOrder = {
                ...order,
                venyek: order.venyek.filter((_, index) => index !== order.aktivVenyIndex),
                aktivVenyIndex: Math.max(0, order.aktivVenyIndex - 1),
            };
            updateOrder(updatedOrder);
            navigate("/VenyekLista");
        } else {
            alert("Ez az egyetlen vény, nem lehet törölni.");
            navigate("/VenyekLista");
        }
    };

    const handleSubmit = async () => {
        setLoading(true);
        const specaidtype = order.hmeliorder?.hmeliorder_specaidtype;

        if (formData.veny_receipt && formData.veny_inscript_date && formData.veny_nine_digit_id && formData.veny_med_name && formData.veny_med_stamp_num && formData.veny_bno_code) {
            const venyek = [...order.venyek];
            venyek[order.aktivVenyIndex] = {
                ...venyek[order.aktivVenyIndex],
                ...formData,
            };

            const updatedOrder = {
                ...order,
                venyek,
            };

            try {
                updateOrder(updatedOrder);

                if (specaidtype === 2) {
                    navigate("/KozgyogyKerdes");
                } else if (specaidtype === 5) {
                    navigate("/EgyediKerdes");
                } else if (specaidtype === 3) {
                    navigate("/UzemiKerdes");
                } else if (specaidtype === 4 && order.hmeliorder?.hmeliorder_depot_prefix === "BETÉT") {
                    navigate("/BetetTartozek");
                } else if (specaidtype === 1 && order.hmeliorder?.hmeliorder_depot_prefix === "BETÉT") {
                    navigate("/BetetTartozek");
                } else if (specaidtype === 1 && order.hmeliorder?.hmeliorder_depot_prefix !== "BETÉT") {
                    navigate("/Mennyiseg");
                } else {
                    navigate("/Mennyiseg");
                }
            } catch (err) {
                alert("Hiba történt a rendelés mentése során: " + (err?.message || err));
            } finally {
                setLoading(false);
            }
        } else {
            setLoading(false);
            alert("Kérjük, töltse ki a kötelező mezőket.");
        }
    };

    const canSubmit = formData.veny_receipt.length === 18 && formData.veny_inscript_date && formData.veny_nine_digit_id.length === 9 && formData.veny_med_name && formData.veny_med_stamp_num && formData.veny_bno_code;

    useEffect(() => {
        if (formData.veny_med_id) {
            setFilteredOrvosok([]);
            return;
        }

        if (orvosSearch.length >= 2) {
            const rendezettOrvosok = [...orvosok].sort((a, b) =>
                a.doctor_full_name.localeCompare(b.doctor_full_name, "hu")
            );
            const keresettSzoveg = orvosSearch.toLowerCase();
            const szurtOrvosok = rendezettOrvosok.filter((orvos) =>
                orvos.doctor_full_name.toLowerCase().includes(keresettSzoveg) ||
                orvos.doctor_stamp_num.toLowerCase().includes(keresettSzoveg)
            );
            setFilteredOrvosok(szurtOrvosok);
        } else {
            setFilteredOrvosok([]);
        }
    }, [orvosSearch, orvosok, formData.veny_med_id]);

    const handleOrvosSelect = (e) => {
        const doctor_szam = e.target.value;
        setOrvosSelectValue(doctor_szam);
        const selectedOrvos = orvosok.find((orvos) => String(orvos.doctor_szam) === String(doctor_szam));
        setFormData({
            ...formData,
            veny_med_name: selectedOrvos ? selectedOrvos.doctor_full_name : "",
            veny_med_stamp_num: selectedOrvos ? selectedOrvos.doctor_stamp_num : "",
            veny_med_id: selectedOrvos ? selectedOrvos.doctor_szam : "",
        });
        setFilteredOrvosok([]);
    };

    useEffect(() => {
        setOrvosSelectValue(formData.veny_med_id ? String(formData.veny_med_id) : "");
    }, [formData.veny_med_id]);

    const handleAddDoctor = async () => {
        setErrorMessage("");
        
        if (!newDoctor.name || !newDoctor.code) {
            setErrorMessage("Kérjük, töltse ki az orvos nevét és pecsétszámát!");
            return;
        }

        if (newDoctor.name.length < 5) {
            setErrorMessage("Az orvos neve túl rövid! Kérjük, adja meg a teljes nevet.");
            return;
        }

        if (!/^\d{5,6}$/.test(newDoctor.code)) {
            setErrorMessage("A pecsétszámnak 5-6 számjegyből kell állnia!");
            return;
        }

        setLoading(true);

        try {
            const response = await dataService.addDoctor({
                doctor_full_name: newDoctor.name.trim(),
                doctor_stamp_num: newDoctor.code.trim()
            });

            if (response.data?.status === "ok") {
                const updatedOrvosok = response.data.data.sort((a, b) =>
                    a.doctor_full_name.localeCompare(b.doctor_full_name, "hu")
                );
                setOrvosok(updatedOrvosok);
                const newDoctorEntry = updatedOrvosok.find(
                    doctor => doctor.doctor_stamp_num === newDoctor.code.trim()
                );

                if (newDoctorEntry) {
                    setFormData({
                        ...formData,
                        veny_med_name: newDoctorEntry.doctor_full_name,
                        veny_med_stamp_num: newDoctorEntry.doctor_stamp_num,
                        veny_med_id: newDoctorEntry.doctor_szam,
                    });
                    setOrvosSearch(newDoctorEntry.doctor_full_name);
                    setFilteredOrvosok([]);
                    setNewDoctor({ name: "", code: "" });
                    setIsAddingDoctor(false);
                }
            } else {
                throw new Error(response.data?.message || "Ismeretlen hiba történt");
            }
        } catch (error) {
            console.error("Hiba az orvos hozzáadása során:", error);
            setErrorMessage(error.response?.data?.message || error.message || "Hiba történt az orvos hozzáadása során. Kérjük, próbálja újra.");
        } finally {
            setLoading(false);
        }
    };

    const [bnoSearch, setBnoSearch] = useState(aktVeny.veny_bno_code || "");
    const [bnoResults, setBnoResults] = useState([]);
    const [isBnoLoading, setIsBnoLoading] = useState(false);
    const [bnoError, setBnoError] = useState("");
    const [hasSelectedBno, setHasSelectedBno] = useState(Boolean(aktVeny.veny_bno_code));
    const [lastSelectedBno, setLastSelectedBno] = useState(aktVeny.veny_bno_code || "");
    const [selectedBnoName, setSelectedBnoName] = useState("");

    useEffect(() => {
        if (bnoSearch.length < 3) {
            setBnoResults([]);
            setIsBnoLoading(false);
            return;
        }

        if (hasSelectedBno && bnoSearch === lastSelectedBno) {
            setBnoResults([]);
            setIsBnoLoading(false);
            return;
        }

        let cancelled = false;
        setIsBnoLoading(true);
        setBnoError("");

        const timeoutId = setTimeout(async () => {
            try {
                const response = await dataService.getBNOs({ code: bnoSearch });
                if (cancelled) return;

                if (response.data?.status === "ok") {
                    setBnoResults(response.data.data ?? []);
                } else {
                    setBnoResults([]);
                    setBnoError(response.data?.message || "Nem sikerült a BNO lista lekérése.");
                }
            } catch (err) {
                if (!cancelled) {
                    setBnoResults([]);
                    setBnoError("BNO lekérés sikertelen, próbáld újra.");
                    console.error("BNO fetch error:", err);
                }
            } finally {
                if (!cancelled) setIsBnoLoading(false);
            }
        }, 300);

        return () => {
            cancelled = true;
            clearTimeout(timeoutId);
        };
    }, [bnoSearch, hasSelectedBno, lastSelectedBno]);

    const handleBnoSelect = (bno) => {
        setFormData((prev) => ({ ...prev, veny_bno_code: bno.code }));
        setBnoSearch(bno.code);
        setBnoResults([]);
        setHasSelectedBno(true);
        setLastSelectedBno(bno.code);
        setSelectedBnoName(bno.name || "");
    };

    return (
        <TablerLayout title="Vényes adatok kitöltése">
            <div className="row justify-content-center">
                <div className="col-md-10 mb-4">

					{process.env.NODE_ENV === 'development' && (
						<div className="mb-3 text-center">
							<button
								type="button"
								className="btn btn-warning btn-sm"
								onClick={fillTestData}
							>
								🧪 Teszt adatok kitöltése (DEV)
							</button>
						</div>
					)}
					
                    <div className="container-xl">
                        <div
                            style={{
                                textAlign: "right",
                                fontWeight: 500,
                                fontSize: "1.1rem",
                                marginBottom: 8,
                            }}
                        >
                            {order.aktivVenyIndex + 1} / {order.venyek.length}. vény
                        </div>
                    </div>
					
                    <div className="card-body">
                        <div className="mb-3">
                            <FloatingLabelInput
                                type="text"
                                inputMode="numeric"
                                label="Vényazonosító *"
                                id="veny_receipt"
                                name="veny_receipt"
                                value={formData.veny_receipt}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, "").slice(0, 18);
                                    setFormData({ ...formData, veny_receipt: val });
                                }}
                                minLength={18}
                                maxLength={18}
                                required
                                disabled={isAddingDoctor}
                            />
                        </div>
                        <div className="mb-3">
                            <FloatingLabelInput type="date" label="Vénykiállítás dátuma *" id="veny_inscript_date" name="veny_inscript_date" value={formData.veny_inscript_date} onChange={handleInputChange} required disabled={isAddingDoctor} />
                        </div>
                        <div className="mb-3">
                            <FloatingLabelInput
                                type="text"
                                inputMode="numeric"
                                label="Kilencjegyű azonosító *"
                                id="veny_nine_digit_id"
                                name="veny_nine_digit_id"
                                value={formData.veny_nine_digit_id}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, "").slice(0, 9);
                                    setFormData({ ...formData, veny_nine_digit_id: val });
                                }}
                                minLength={9}
                                maxLength={9}
                                required
                                disabled={isAddingDoctor}
                            />
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-9">
                                <FloatingLabelInput
                                    type="text"
                                    label="Orvos neve *"
                                    id="veny_med_name"
                                    name="veny_med_name"
                                    value={orvosSearch}
                                    onChange={(e) => {
                                        setOrvosSearch(e.target.value);
                                        setFormData({
                                            ...formData,
                                            veny_med_name: e.target.value,
                                            veny_med_stamp_num: "",
                                            veny_med_id: "",
                                        });
                                    }}
                                    required
                                    disabled={isAddingDoctor}
                                />
                            </div>
                            <div className="col-md-3 d-flex align-items-center">
                                <button
                                    type="button"
                                    className="btn fs-5 btn-primary btn-sm w-100"
                                    onClick={() => {
                                        setIsAddingDoctor(true);
                                        setFormData({
                                            ...formData,
                                            veny_med_name: "",
                                            veny_med_stamp_num: "",
                                            veny_med_id: "",
                                        });
                                        setOrvosSearch("");
                                    }}
                                    disabled={isAddingDoctor}
                                >
                                    <IconCopyPlus
                                        size={24}
                                        stroke={2}
                                    /> Új orvos
                                </button>
                            </div>
                        </div>
                        {orvosSearch.length >= 2 && filteredOrvosok.length > 0 && (
                            <div className="row mb-3">
                                <div className="col">
                                    <div className="table-responsive">
                                        <table className="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Orvos neve</th>
                                                    <th>Pecsétszám</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredOrvosok.map((orvos) => (
                                                    <tr
                                                        key={orvos.doctor_szam}
                                                        onClick={() => {
                                                            setFormData({
                                                                ...formData,
                                                                veny_med_name: orvos.doctor_full_name,
                                                                veny_med_stamp_num: orvos.doctor_stamp_num,
                                                                veny_med_id: orvos.doctor_szam,
                                                            });
                                                            setOrvosSearch(orvos.doctor_full_name);
                                                        }}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <td>{orvos.doctor_full_name}</td>
                                                        <td>{orvos.doctor_stamp_num}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}
                        {isAddingDoctor && (
                            <div className="row g-2 mb-3">
                                <div className="col-md-6">
                                    <FloatingLabelInput
                                        type="text"
                                        label="Orvos neve"
                                        id="newDoctorName"
                                        name="newDoctorName"
                                        value={newDoctor.name}
                                        onChange={(e) =>
                                            setNewDoctor({ ...newDoctor, name: e.target.value })
                                        }
                                        required
                                        disabled={loading}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <FloatingLabelInput
                                        type="text"
                                        label="Orvosi pecsétszám"
                                        id="newDoctorCode"
                                        name="newDoctorCode"
                                        value={newDoctor.code}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/\D/g, "").slice(0, 6);
                                            setNewDoctor({ ...newDoctor, code: val });
                                        }}
                                        required
                                        maxLength={6}
                                        disabled={loading}
                                    />
                                </div>
                                <div className="col-md-12">
                                    {errorMessage && (
                                        <div className="alert alert-danger mb-3" role="alert">
                                            {errorMessage}
                                        </div>
                                    )}
                                    <div className="text-end">
										{loading && (
											<ShoeLoader text={false}/>
										)}	
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-lg me-2"
                                            style={{ padding: "12px 24px", fontSize: "1.2rem", minWidth: "120px" }}
                                            onClick={handleAddDoctor}
                                            disabled={loading}
                                        >
											Mentés
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary btn-lg"
                                            style={{ padding: "12px 24px", fontSize: "1.2rem" }}
                                            onClick={() => {
                                                setIsAddingDoctor(false);
                                                setErrorMessage("");
                                            }}
                                            disabled={loading}
                                        >
                                            Mégsem
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="mb-3">
							<FloatingLabelInput
								type="text"
								label="Orvosi pecsétszám"
								id="veny_med_stamp_num"
								name="veny_med_stamp_num"
								value={formData.veny_med_stamp_num}
								onChange={handleInputChange}
								required
								disabled={true}
							/>
						</div>
						<div className="mb-3">
							<FloatingLabelInput
								type="text"
								label="BNO kód*"
								id="veny_bno_code"
								name="veny_bno_code"
                                addon={selectedBnoName}
								value={bnoSearch}
								onChange={(e) => {
									const val = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 5);
                                    setHasSelectedBno(false);
                                    setLastSelectedBno("");
                                    setSelectedBnoName("");
									setBnoSearch(val);
									setFormData((prev) => ({ ...prev, veny_bno_code: val }));
								}}
								maxLength={5}
								required
								disabled={isAddingDoctor}
							/>
						</div>
                    </div>
                    {bnoSearch.length >= 3 && !(hasSelectedBno && bnoSearch === lastSelectedBno) && (
                        <div className="row mb-3">
                            <div className="col">
                            {isBnoLoading && (
                                <div className="d-flex justify-content-center py-2">
                                <ShoeLoader text={false} />
                                </div>
                            )}

                            {!isBnoLoading && bnoResults.length > 0 && (
                                <div className="table-responsive">
                                <table className="table table-hover">
                                    <thead>
                                    <tr>
                                        <th>BNO kód</th>
                                        <th>Megnevezés</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {bnoResults.map((bno) => (
                                        <tr
                                        key={bno.code}
                                        onClick={() => handleBnoSelect(bno)}
                                        style={{ cursor: "pointer" }}
                                        >
                                        <td>{bno.code}</td>
                                        <td>{bno.name}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                </div>
                            )}

                            {!isBnoLoading && bnoResults.length === 0 && !bnoError && (
                                <div className="text-muted fst-italic">
                                Nincs találat a megadott kódra.
                                </div>
                            )}

                            {bnoError && (
                                <div className="alert alert-danger mt-2" role="alert">
                                {bnoError}
                                </div>
                            )}
                            </div>
                        </div>
                        )}
                    <div className="row mt-0">
                        <div className="col-12 col-sm-12 col-md-12">
                            <span style={{ color: "gray" }}>A csillaggal megjelölt mezők kitöltése kötelező!</span>
                        </div>
                    </div>

                    {/* {order.venyek.length > 1 && (
                        <div className="row g-3 mt-4 d-flex justify-content-center">
                            <div className="col-12 col-sm-6 col-md-6">
                                <button type="button" className="btn btn-md btn-secondary w-100" onClick={cancelAdd}>
                                    Mégsem, vissza a vényekhez
                                </button>
                            </div>
                        </div>
                    )} */}
                </div>

                
            </div>
            <div className="d-flex justify-content-between mt-4">
                    <StepperNavButton side="left" label="Vissza a listára" onClick={() => navigate("/VenyekLista")} />
                    <StepperNavButton side="right" label="Tovább" onClick={handleSubmit} disabled={!canSubmit} />
                </div>
        </TablerLayout>
    );
};

export default AdatVenyes;
